import { EnumDialogName } from '@calm/evexia-analytics';
import { AudioPlayerDialog } from '@rhg/components/media/audio-player-dialog';
import { AudioPlayerDrawer } from '@rhg/components/media/audio-player-drawer';
import { useCallback } from 'react';
import { AudioPlayerControls } from '../audio-player/types';
import { AudioPlayerCombinedProps } from './types';

export function AudioPlayerCombined({
    openState = false,
    title,
    subtitle,
    description,
    imageSrc,
    autoplay,
    drawerAction,
    dialogAction,
    dialogBottomAction,
    drawerTitleIcon,
    narrators,
    authors,
    playerAudio,
    previousProgress,
    controls = AudioPlayerControls.Regular,
    setOpenState,
    onProgress,
    onClose,
    onEnd,
    onNextTrack,
    onPreviousTrack,
    trackDialog = EnumDialogName.AudioPlayer,
    trackProps,
    onControlClick,
}: AudioPlayerCombinedProps) {
    const onMaximize = useCallback(() => {
        setOpenState('dialog');
    }, [setOpenState]);

    const onMinimize = useCallback(() => {
        setOpenState('drawer');
    }, [setOpenState]);

    const onEndCallback = useCallback(() => {
        onEnd?.();
    }, [onEnd]);

    if (!playerAudio) {
        return null;
    }
    switch (openState) {
        case 'drawer':
            return (
                <AudioPlayerDrawer
                    audio={playerAudio}
                    isOpen
                    title={title}
                    drawerTitleIcon={drawerTitleIcon}
                    subtitle={subtitle}
                    imageSrc={imageSrc}
                    controls={controls}
                    autoplay={autoplay}
                    previousProgress={previousProgress}
                    customAction={drawerAction}
                    onMaximize={onMaximize}
                    onProgress={onProgress}
                    onEnd={onEndCallback}
                    onClose={() => onClose?.()}
                    onNextTrack={onNextTrack}
                    onPreviousTrack={onPreviousTrack}
                    onControlClick={onControlClick}
                />
            );

        case 'dialog':
            return (
                <AudioPlayerDialog
                    audio={playerAudio}
                    isOpen
                    title={title}
                    description={description}
                    narrators={narrators}
                    authors={authors}
                    imageSrc={imageSrc}
                    isCloseButtonDisplayed={true}
                    controls={controls}
                    autoplay={autoplay}
                    trackDialog={trackDialog}
                    trackProps={trackProps}
                    previousProgress={previousProgress}
                    onMinimize={onMinimize}
                    upperActionButton={dialogAction}
                    dialogBottomAction={dialogBottomAction}
                    onProgress={onProgress}
                    onEnd={onEndCallback}
                    onClose={() => onClose?.()}
                    onNextTrack={onNextTrack}
                    onPreviousTrack={onPreviousTrack}
                    onControlClick={onControlClick}
                />
            );

        default:
            return null;
    }
}
